<template>
<div class="chapter">
<div class="inner_page">
<h1>Copyright</h1>
<p class="sectiontop" style="text-align: center;">Diversion Books<br/>
  A Division of Diversion Publishing Corp.<br/>
  443 Park Avenue South, Suite 1008<br/>
  New York, NY 10016<br/>
<a href="http://www.DiversionBooks.com" target="_blank">www.DiversionBooks.com</a></p>
<p class="sectiontop" style="text-align: center;">Copyright © 1988 by Jane Vaughan<br/>
  All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
<p class="sectiontop" style="text-align: center;">This is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.</p>
<p class="sectiontop" style="text-align: center;">For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a></p>
<p class="sectiontop" style="text-align: center;">First Diversion Books edition February 2015<br/>
  ISBN: 978-1-62681-669-5</p>
<div style="page-break-after: always;">
<div style="display: none;"></div>
</div>
<h1 class="sigil_not_in_toc">Also by Vivian Vaughan</h1>
<p class="sectiontop" style="text-align: center;"><span href="#/Text/morefrom" title="Link target outside of Sample">A Wish to Build a Dream On<br/>
  Storms Never Last<br/>
  Sweetheart of the Rodeo</span></p>
<p class="sectiontop" style="text-align: center;"><span href="#/Text/morefrom" title="Link target outside of Sample"><b>The Texas Star Trilogy</b><br/>
  Texas Gamble<br/>
  Texas Dawn<br/>
  Texas Gold</span></p>
<p class="sectiontop" style="text-align: center;"><span href="#/Text/morefrom" title="Link target outside of Sample"><b>Silver Creek Stories</b><br/>
  Heart’s Desire<br/>
  Texas Twilight<br/>
  Sweet Texas Nights</span></p>
<div style="page-break-after: always;">
<div style="display: none;"></div>
</div>
<p class="sectiontop" style="text-align: center;"><i>Toe to Toe, Eye to Eye,<br/>
  Esther, Dear Girl,<br/>
  This One’s for YOU!</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01c_copy.vue?720df0da